import { z } from "zod";
import {
  sourceTypeEnum,
  authorityLevelEnum,
  sourceStatusEnum,
} from "./enums.js";

export const sourceSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  name: z.string().min(1),
  sourceType: sourceTypeEnum,
  authorityLevel: authorityLevelEnum,
  url: z.string().url().nullable(),
  language: z.string().nullable(),
  metadata: z.record(z.string(), z.unknown()).default({}),
  crawlSchedule: z.string().nullable(),
  lastCrawledAt: z.date().nullable(),
  status: sourceStatusEnum,
  errorMessage: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type Source = z.infer<typeof sourceSchema>;

export const sourceVersionSchema = z.object({
  id: z.string().uuid(),
  sourceId: z.string().uuid(),
  versionNumber: z.number().int().positive(),
  effectiveFrom: z.date(),
  effectiveUntil: z.date().nullable(),
  originalFile: z.string().nullable(),
  contentHash: z.string(),
  parserVersion: z.string().nullable(),
  chunkingStrategy: z.string().nullable(),
  embeddingModel: z.string().nullable(),
  createdAt: z.date(),
});

export type SourceVersion = z.infer<typeof sourceVersionSchema>;
